import { IconButtonProps, DropdownItem } from '@optimus-web/core';
import { LocalizedText, useDialog } from '@mews/framework';
import { DetailedPlatformProfileResult } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { ResetAuthenticatorPlatformProfileDialog } from './ResetAuthenticatorPlatformProfileDialog';

export const ResetAuthenticatorPlatformProfileButton = (
    props: Pick<IconButtonProps, 'disabled'> & { data: DetailedPlatformProfileResult }
) => {
    const [{ active, onClose }, openDialog] = useDialog();
    const { data } = props;
    return (
        <>
            <DropdownItem
                key="resetMFA"
                label={<LocalizedText textKey={TextKey.ResetTwoFactorShort} />}
                onClick={openDialog}
            />
            {active && <ResetAuthenticatorPlatformProfileDialog platformProfile={data} onClose={onClose} />}
        </>
    );
};
